import { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export const CheckPrimeAccount = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const apiToken = localStorage.getItem("api_token");
    const tokenType = localStorage.getItem("token_type");
    const loginType = localStorage.getItem("login_type");

    if (!accessToken || !apiToken || !tokenType || !loginType) {
      navigate("/login");
    } else if (loginType !== "prime") {
      navigate("/analytics");
    } else {
      setLoading(false);
    }
  }, [navigate]);

  if (loading) {
    return null;
  }

  return <Outlet />;
};
